<script>
import request from '@/request'
import colors from '@/utils/colors'
import { PublicHeader, BarChart, LineChart2 as LineChart } from '@/components/common/'
import { Breadcrumb } from '../../../components';

export default {
    name: 'selecionados',
    components: {
        PublicHeader,
        Breadcrumb,
        BarChart,
        LineChart
    },
    data() {
        return {
            selecionados: [],
            dados: [],
            comparativos: [],
            cores: colors.coresHexa,
            tipoGrafico: 'bar',
            tipoComparativo: 'soma'
        }
    },
    methods: {
        toDate(dateStr) {
            const [day, month, year] = dateStr.split("/")
            return new Date(year, month - 1, day)
        },
        adicionarComparativo(id, nome) {
            request.get(
                'selecionados/valores/' + id,
                response => {
                    const { datas, valores } = response

                    this.dados.push(
                        {
                            'codigo': id,
                            'nome': nome,
                            'valores': valores,
                            'datas': datas
                        }
                    )

                    let aux = {}
                    for (let index = 0; index < datas.length; index++) {
                        const data_dado = this.toDate(datas[index])
                        aux[data_dado.getFullYear()] = valores[index]
                    }

                    this.comparativos.push(aux)
                },
                response => {
                    this.$toastr.e(response)
                }
            )
        },
        removerComparativo(item) {
            this.dados.splice(item, 1)
            this.comparativos.splice(item, 1)
        },
        permitirComparativo(selecionado) {
            if (selecionado.tipo === 'T' ||
                this.dados.findIndex(val => val.codigo === selecionado.codigo) > -1 ||
                this.dados.length > 4) {
                return false
            }

            return true
        },
        retornaSoma(grafico) {
            let result = [...this.comparativos]
            const anos = grafico.labels

            grafico.datasets.push({
                label: 'Soma Simples',
                backgroundColor: '#de1a1a',
                data: []
            })

            result = result.reduce((acumulador, atual) => {
                let res = {}
                for (let index = 0; index < anos.length; index++) {
                    res[anos[index]] = (parseFloat(acumulador[anos[index]]) || 0) + (parseFloat(atual[anos[index]]) || 0)
                }

                return res
            })

            for (let index = 0; index < anos.length; index++) {
                grafico.datasets[0].data.push(result[anos[index]])
            }

            return grafico
        },
        retornaMediaSimples(grafico) {
            let result = this.retornaSoma(grafico)
            result.datasets[0].label = 'Média simples'
            result.datasets[0].data = result.datasets[0].data.map(valor => valor / this.comparativos.length)

            return result
        },
        retornaMediaAnual(grafico) {
            const base = [...this.comparativos]
            let result = {
                ...grafico,
                labels: ['Média Anual']
            }

            for (let index = 0; index < base.length; index++) {
                const anos = Object.keys(base[index])
                let acumulador = 0

                for (let subindex = 0; subindex < anos.length; subindex++) {
                    acumulador += parseFloat(base[index][anos[subindex]]) || 0
                }

                result.datasets.push({
                    label: `Dado ${index + 1}`,
                    data: [acumulador / anos.length]
                })
            }

            return result
        },
        retornaRelacao(grafico) {
            let result = { ...grafico }
            const anos = result.labels
            let base = []

            for (let index = 0; index < 2; index++) {
                base.push({ ...this.comparativos[index] })
            }

            let relacao = base.reduce((acumulador, atual) => {
                let res = []
                for (let index = 0; index < anos.length; index++) {
                    res.push((parseFloat(acumulador[anos[index]]) || 0) / (parseFloat(atual[anos[index]]) || 1))
                }

                return res
            })

            result.datasets.push({
                label: 'Relação Dado 1 / Dado 2',
                data: relacao
            })

            return result
        }
    },
    mounted() {
        const ids = this.$route.params.ids;

        if (ids) {
            const idsArray = ids.split(',');

            let queryString = idsArray.map((id, index) => `${index}=${id}`).join('&');

            request.get(
                `selecionados?${queryString}`,
                response => {
                    this.selecionados = response;
                },
                response => {
                    console.log(response);
                }
            );
        } else {
            console.error('Parâmetros da URL não encontrados');
        }
    },
    computed: {
        labels_grafico() {
            const base = [2014]
            const periodicidade = this.selecionados[
                this.selecionados.findIndex(val => val.codigo === this.dados[0].codigo)
            ].periodicidade

            if (periodicidade === 6) {
                let data = new Date()
                while (base[base.length - 1] < data.getFullYear() - 1) {
                    base.push(base[base.length - 1] + 1)
                }
            }

            return base
        },
        dados_grafico() {
            const anos = this.labels_grafico
            const dados = [...this.comparativos]
            let base = {
                labels: this.labels_grafico,
                datasets: [
                ]
            }

            for (let index = 0; index < dados.length; index++) {
                base.datasets.push({
                    label: '',
                    data: []
                })

                for (let subindex = 0; subindex < anos.length; subindex++) {
                    base.datasets[index].data.push(dados[index][anos[subindex]]);
                }
            }

            return base
        },
        dados_comparativos() {
            let grafico = {
                labels: this.labels_grafico,
                datasets: []
            }

            switch (this.tipoComparativo) {
                case 'soma':
                    return this.retornaSoma(grafico)
                case 'mediaSimples':
                    return this.retornaMediaSimples(grafico)
                case 'mediaAnual':
                    return this.retornaMediaAnual(grafico)
                case 'relacao':
                    return this.retornaRelacao(grafico)
                default:
                    return grafico
            }
        },
        breadcrumblinks() {
            const baseRoute = this.$route.query.origem === 'dados-secretaria'
                ? '/listar/dados-secretaria'
                : '/listar/dados';

                return [
                    { label: 'Listagem', link: baseRoute },
                    { label: 'Comparar dados' }
                ];
        }
    }
}
</script>

<template>
    <div class="row">
        <PublicHeader :title="'Comparar Dados'">
            <div class="col-xs-12 col-sm-6">
                <p>
                    Abaixo você encontra os dados selecionados para ser realizada a comparação.
                </p>
            </div>
        </PublicHeader>
        <div class="container comparativos">
            <Breadcrumb :links="breadcrumblinks" />
            <div class="row">
                <div class="col-xs-12">
                    <h3>Comparativos Disponíveis</h3>
                </div>
                <div class="col-xs-12 col-md-6 linha-detalhe" v-for="selecionado in selecionados" :key="selecionado.codigo">
                    <div class="row">
                        <div class="col-xs-9">
                            <p>{{ selecionado.nome }}</p>
                        </div>
                        <div class="col-xs-3 text-left">
                            <button v-if="permitirComparativo(selecionado)" class="btn btn-primary"
                                @click="adicionarComparativo(selecionado.codigo, selecionado.nome)"
                                title="Adicionar Comparativo">
                                <font-awesome-icon :icon="'plus'"></font-awesome-icon>
                            </button>
                            <router-link title="Listar valores" class="btn btn-primary"
                                :to="{ name: 'public_detalhes', params: { id: selecionado.codigo } }">
                                <font-awesome-icon :icon="'chart-bar'"></font-awesome-icon>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <transition name="fade" mode="in-out">
                <div class="row" v-if="dados.length">
                    <div class="col-sm-6">
                        <h3>Dados</h3>
                        <p v-for="(item, index) in dados" v-bind:key="index">
                            {{ item.nome }} -
                            <font-awesome-icon :icon="'square'" :style="{ color: cores[index] }"></font-awesome-icon>
                            <a role="button" title="remover este item do comparativo" @click="removerComparativo(index)">
                                <font-awesome-icon :icon="'trash-alt'" :style="{ color: '#d9534f' }"></font-awesome-icon>
                            </a>
                        </p>
                        <div class="radio">
                            <label><input type="radio" v-model="tipoGrafico" value="bar" name="radiograph" checked />Gráfico
                                de barras</label>
                        </div>
                        <div class="radio">
                            <label><input type="radio" v-model="tipoGrafico" value="line" name="radiograph" />Gráfico de
                                linhas</label>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <bar-chart v-if="tipoGrafico === 'bar'" ref="graph_barra" :css-classes="'chart-container'"
                            :chart-data="dados_grafico" :gradiente="false" :options="{
                                responsive: true,
                                maintainAspectRatio: false,
                                legend: {
                                    display: true
                                },
                                scales: {
                                    yAxes: [
                                        {
                                            ticks: {
                                                beginAtZero: true,
                                                suggestedMax: 50
                                            }
                                        }
                                    ],
                                    xAxes: [
                                        {
                                            maxBarThickness: 50
                                        }
                                    ]
                                }
                            }"></bar-chart>
                        <line-chart v-if="tipoGrafico === 'line'" ref="graph_linha" :css-classes="'chart-container'"
                            :chart-data="dados_grafico" :gradiente="false" :coloredLine="true" :options="{
                                responsive: true,
                                maintainAspectRatio: false,
                                legend: {
                                    display: true
                                },
                                scales: {
                                    yAxes: [
                                        {
                                            ticks: {
                                                beginAtZero: true,
                                                suggestedMax: 50
                                            }
                                        }
                                    ],
                                    xAxes: [
                                        {
                                            maxBarThickness: 50
                                        }
                                    ]
                                },
                                elements: {
                                    line: {
                                        fill: false,
                                        borderWidth: 4
                                    },
                                    point: {
                                        radius: 5,
                                        hoverRadius: 6
                                    }
                                }
                            }"></line-chart>
                    </div>
                </div>
            </transition>
            <transition mode="in-out">
                <div class="row" v-if="dados.length > 1">
                    <div class="col-sm-6">
                        <h3>Comparativos</h3>
                        <p v-for="(item, index) in dados" v-bind:key="index">
                            {{ item.nome }} - <b>Dado {{ index + 1 }}</b>
                            <a role="button" title="remover este item do comparativo" @click="removerComparativo(index)">
                                <font-awesome-icon :icon="'trash-alt'" :style="{ color: '#d9534f' }"></font-awesome-icon>
                            </a>
                        </p>
                        <div class="radio">
                            <label><input type="radio" v-model="tipoComparativo" value="soma" name="radiocomparativo"
                                    checked />Soma Simples (Dado 1 + Dado 2 + ... + Dado N)</label>
                        </div>
                        <div class="radio">
                            <label><input type="radio" v-model="tipoComparativo" value="mediaSimples"
                                    name="radiocomparativo" />Média Simples ((Dado 1 + Dado 2 + ... + Dado N) / N)</label>
                        </div>
                        <div class="radio">
                            <label><input type="radio" v-model="tipoComparativo" value="mediaAnual"
                                    name="radiocomparativo" />Média Anual ((Ano 1 + Ano 2 + ... + Ano N ) / N)</label>
                        </div>
                        <div class="radio">
                            <label><input type="radio" v-model="tipoComparativo" value="relacao"
                                    name="radiocomparativo" />Relação (Dado 1 / Dado 2)</label>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <bar-chart ref="grafico_comparativo" :css-classes="'chart-container'"
                            :chart-data="dados_comparativos" :gradiente="false" :options="{
                                responsive: true,
                                maintainAspectRatio: false,
                                legend: {
                                    display: true
                                },
                                scales: {
                                    yAxes: [
                                        {
                                            ticks: {
                                                beginAtZero: true
                                            }
                                        }
                                    ],
                                    xAxes: [
                                        {
                                            maxBarThickness: 50
                                        }
                                    ]
                                }
                            }"></bar-chart>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<style>
.comparativos .linha-detalhe {
    padding-top: 5px;
    padding-bottom: 5px;
}

.comparativos .linha-detalhe:hover {
    background-color: #f0f0f0;
}
</style>


// WEBPACK FOOTER //
// src/views/public/dados/compare.vue